import type { DmCoreRequest } from '../http/request'
import type {
  DMCoreNxgAccessTokenParams,
  DMCoreNxgAccessTokenResponse,
  DMCoreSpaceOperatorClientDetailsParams,
  DMCoreSpaceOperatorData,
  DMCoreSpaceOperatorLoginParams,
  DMCoreSpaceOperatorLoginResponse,
  DMCoreSpaceOperatorLogoutParams,
  DMCoreSpaceOperatorRefreshTokenParams,
  DMCoreSpaceOperatorTokenRefreshResponse
} from '../types/spaceOperator'

export interface SpaceOperatorContext {
  tenantUuid: string
  deviceUuid: string
}

export const createSpaceOperatorApi = (request: DmCoreRequest, context: SpaceOperatorContext) => ({
  login: (params: DMCoreSpaceOperatorLoginParams): Promise<DMCoreSpaceOperatorLoginResponse> =>
    request({
      method: 'POST',
      path: `/space/${context.tenantUuid}/operator/login/`,
      body: {
        username: params.username,
        password: params.password,
        device_uuid: context.deviceUuid
      },
      auth: false
    }),

  getClientDetails: (
    params: DMCoreSpaceOperatorClientDetailsParams
  ): Promise<DMCoreSpaceOperatorData> =>
    request({
      method: 'GET',
      path: `/space/${context.tenantUuid}/operator/${params.operatorUuid}/client-details/`
    }),

  refreshToken: (
    params: DMCoreSpaceOperatorRefreshTokenParams
  ): Promise<DMCoreSpaceOperatorTokenRefreshResponse> =>
    request({
      method: 'POST',
      path: '/token/refresh/',
      body: {
        refresh_token: params.refresh_token
      },
      auth: false
    }),

  logout: (params: DMCoreSpaceOperatorLogoutParams): Promise<void> =>
    request({
      method: 'POST',
      path: `/space/${context.tenantUuid}/operator/${params.operatorUuid}/logout/`,
      body: {
        device_uuid: context.deviceUuid
      }
    }),

  getNxgAccessToken: (
    params: DMCoreNxgAccessTokenParams
  ): Promise<DMCoreNxgAccessTokenResponse> =>
    request({
      method: 'GET',
      path: `/space/${context.tenantUuid}/device/${context.deviceUuid}/api-key/nxg-access-token/`,
      headers: { 'X-Api-Key': params.apiKey },
      auth: false
    })
})

export type SpaceOperatorApi = ReturnType<typeof createSpaceOperatorApi>
